import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControlLabel,
  Paper,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { api } from "../../../Config/Api";

interface NotificationBarConfig {
  enabled: boolean;
  message: string;
  backgroundColor: string;
  textColor: string;
  scrolling: boolean;
  scrollSpeed: number;
}

const defaultConfig: NotificationBarConfig = {
  enabled: false,
  message: "",
  backgroundColor: "#00927c",
  textColor: "#ffffff",
  scrolling: false,
  scrollSpeed: 18,
};

const NotificationBarSettings = () => {
  const [config, setConfig] = useState<NotificationBarConfig>(defaultConfig);

  const fetchConfig = async () => {
    try {
      const jwt = localStorage.getItem("jwt");
      const { data } = await api.get("/admin/notification-bar", {
        headers: jwt ? { Authorization: `Bearer ${jwt}` } : {},
      });
      setConfig({ ...defaultConfig, ...data });
    } catch (error) {
      console.log("Failed to fetch notification config", error);
    }
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  const handleSave = async () => {
    try {
      const jwt = localStorage.getItem("jwt");
      await api.patch("/admin/notification-bar", config, {
        headers: jwt ? { Authorization: `Bearer ${jwt}` } : {},
      });
      alert("Notification bar updated successfully");
    } catch (error) {
      console.log("Failed to save notification config", error);
      alert("Failed to update notification bar");
    }
  };

  const handleRefreshCache = async () => {
    try {
      const jwt = localStorage.getItem("jwt");
      await api.post(
        "/admin/notification-bar/refresh-cache",
        {},
        {
          headers: jwt ? { Authorization: `Bearer ${jwt}` } : {},
        }
      );
      alert("Notification cache refreshed");
    } catch (error) {
      console.log("Failed to refresh cache", error);
      alert("Failed to refresh cache");
    }
  };

  return (
    <Box p={3}>
      <Paper sx={{ p: 3, borderRadius: "16px", maxWidth: 700 }}>
        <Typography variant="h5" fontWeight={700} mb={3}>
          Notification Bar Settings
        </Typography>

        <Stack spacing={3}>
          <FormControlLabel
            control={
              <Switch
                checked={config.enabled}
                onChange={(e) =>
                  setConfig({ ...config, enabled: e.target.checked })
                }
              />
            }
            label="Enable notification bar"
          />

          <TextField
            label="Message"
            fullWidth
            multiline
            minRows={3}
            value={config.message}
            onChange={(e) =>
              setConfig({ ...config, message: e.target.value })
            }
          />

          <FormControlLabel
            control={
              <Switch
                checked={config.scrolling}
                onChange={(e) =>
                  setConfig({ ...config, scrolling: e.target.checked })
                }
              />
            }
            label="Enable scrolling"
          />

          <TextField
            label="Scroll Speed (seconds)"
            type="number"
            fullWidth
            value={config.scrollSpeed}
            onChange={(e) =>
              setConfig({
                ...config,
                scrollSpeed: Number(e.target.value),
              })
            }
          />

          <Box className="flex gap-4 flex-col sm:flex-row">
            <Box className="flex flex-col gap-2">
              <Typography variant="body2">Background Color</Typography>
              <input
                type="color"
                value={config.backgroundColor}
                onChange={(e) =>
                  setConfig({ ...config, backgroundColor: e.target.value })
                }
              />
            </Box>

            <Box className="flex flex-col gap-2">
              <Typography variant="body2">Text Color</Typography>
              <input
                type="color"
                value={config.textColor}
                onChange={(e) =>
                  setConfig({ ...config, textColor: e.target.value })
                }
              />
            </Box>
          </Box>

          <Box className="flex gap-3 flex-wrap">
            <Button variant="contained" onClick={handleSave}>
              Save
            </Button>

            <Button variant="outlined" onClick={handleRefreshCache}>
              Refresh Cache
            </Button>
          </Box>
        </Stack>
      </Paper>
    </Box>
  );
};

export default NotificationBarSettings;